import MyHouseCard from './MyHouseCard';

export default MyHouseCard;
